module.exports = __webpack_public_path__ + "img/s2-computer.a654199c.png";